import apis from '@apis/index';
import axios from 'axios';
import React, { useState, useCallback, useEffect } from 'react';

export default function useUpload({
  defaultUrl,
  bucketName,
}: {
  defaultUrl?: string;
  bucketName: string;
}) {
  const [uploadUrl, setUploadUrl] = useState<string | string[] | undefined>(
    defaultUrl || undefined,
  );
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const [errorMessage, setErrorMesage] = useState('');
  const handleFileChange = async (event: React.ChangeEvent) => {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length > 0) {
      const file = target.files[0];
      const formData = new FormData();
      formData.append('image', file);

      try {
        setIsUploading(true);
        const { data } = await apis.util.uploadSingleImage(
          bucketName,
          formData,
        );
        setUploadUrl(data);
      } catch (e) {
        console.log(e);
      } finally {
        setIsUploading(false);
      }
    }
  };

  useEffect(() => {
    setUploadUrl(defaultUrl);
  }, [defaultUrl]);
  useEffect(() => {
    if (uploadUrl && errorMessage) setErrorMesage('');
  }, [uploadUrl]);

  const resetUpload = () => setUploadUrl(undefined);

  return {
    uploadUrl,
    handleFileChange,
    resetUpload,
    isUploading,
    errorMessage,
  };
}
